import ApplicationLogo from '@/Components/ApplicationLogo';
import {Link} from '@inertiajs/react';
import {PropsWithChildren} from 'react';
import {Toaster} from "react-hot-toast";

export default function GuestLayoutCompact({children}: PropsWithChildren) {
    return (
        <div className="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100 dark:bg-gray-900">
            <div>
                <Link href={route('home')}>
                    <ApplicationLogo className="w-20 h-20 fill-current text-gray-500 dark:text-gray-400"/>
                </Link>
            </div>

            <div className="w-full sm:max-w-md mt-8 px-6 py-4 bg-white dark:bg-gray-800 shadow-md overflow-hidden sm:rounded-lg">
                {children}
            </div>
            <Toaster/>
        </div>
    );
}
